export const getFromToDate = (
    date?: (Date | string)[]
): [Date, Date] | null => {
    if (date?.length !== 2) return null;

    const [from, to] = date;

    const fromDate = new Date(from);
    fromDate.setHours(0, 0, 0, 0);

    const toDate = new Date(to);
    toDate.setHours(23, 59, 59, 999);

    return [fromDate, toDate];
};
